// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "vendors" + "." + "0a9bb87383fe53b2aaf2" + ".js";
};